<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KvS6HB/tc-custom/9781467727433.jpg?1718164014096" alt="This image is the cover for the book Oh Boy, Mallory, Mallory"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oh Boy, Mallory, Mallory
      </h1>
      <p class="bookDescription body article font2">
        <p>Mallory has a new diary, and big news to write in it: a cute fifth-grade boy LIKES her! The only problem: Mallory's friends are more excited about it than she is. Mallory's not sure what to do, what to say on the phone, or even how she feels. Her best friend, Mary Ann, however, <i>is </i>sure about what Mallory should feel and do. But when Mallory follows Mary Ann's advice, she winds up hurting another friend—and gets in BIG trouble. Can Mallory make things right and learn to follow her own heart?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Friedman, Jennifer Kalis
      </h2>
      
      <p class="authorDescription body article"><B>Jennifer Kalis</B> is the illustrator of several <B>Mallory</B> books including <I>Mallory's Super Sleepover</I>,&#160;<I>Mallory in the Spotlight</I>,&#160;and <I>Mallory Goes Green</I>! She lives in Ohio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Minneapolis
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e3678a7